(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-lm-navigation]').forEach(nav => {
      if (nav.dataset.lmBound) return;
      nav.dataset.lmBound = 'true';
      const desktop = window.matchMedia('(min-width: 1025px)');
      const mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
      const triggers = [...nav.querySelectorAll('.lm-nav__trigger[aria-controls]')];
      let active = null;
      let enterTimer;
      let leaveTimer;
      const panelFor = trigger => document.getElementById(trigger.getAttribute('aria-controls'));
      function close(restore = false) {
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
        if (!active) return;
        const previous = active;
        panelFor(previous).hidden = true;
        previous.setAttribute('aria-expanded', 'false');
        active = null;
        if (restore) previous.focus();
      }
      function open(trigger, focusFirst = false) {
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
        if (!desktop.matches) return;
        if (active !== trigger) close();
        active = trigger;
        panelFor(trigger).hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        if (focusFirst) panelFor(trigger).querySelector('a')?.focus();
      }
      triggers.forEach((trigger, index) => {
        const item = trigger.closest('.lm-nav__item');
        item.addEventListener('pointerenter', () => {
          if (!mouse.matches) return;
          clearTimeout(leaveTimer);
          clearTimeout(enterTimer);
          enterTimer = setTimeout(() => open(trigger), 150);
        });
        item.addEventListener('pointerleave', () => {
          if (!mouse.matches) return;
          clearTimeout(enterTimer);
          leaveTimer = setTimeout(() => {
            if (!item.contains(document.activeElement)) close();
          }, 230);
        });
        trigger.addEventListener('click', () => active === trigger ? close() : open(trigger));
        trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') { event.preventDefault(); open(trigger, true); }
          if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
            event.preventDefault();
            close();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? triggers.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + triggers.length) % triggers.length;
            triggers[next].focus();
          }
        });
      });
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && active) { event.preventDefault(); close(true); }
      });
      nav.querySelectorAll('.lm-nav__close').forEach(button => button.addEventListener('click', () => close(true)));
      nav.addEventListener('focusout', () => {
        queueMicrotask(() => { if (!nav.contains(document.activeElement)) close(); });
      });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });
      desktop.addEventListener('change', () => close());
      window.addEventListener('blur', () => close());
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
